import { useEffect } from 'react';

const AboutMe = () => {
  const aboutMeContents = [
    '안녕하세요. 프론트엔드 개발자 김동현입니다.',
    '주로 사용하는 기술은 TypeScript, React 입니다.',
    '최근에는 Next.js 에 관심이 있습니다.',
    '개발을 통해 사용자에게 즐거움과 가치를 전달하고 싶으며',
    '사용자 입장에서 늘 고민하는 개발자가 되고 싶습니다.',
    '소통과 배움을 통해 꾸준히 성장하는 프론트엔드 개발자가 되겠습니다.',
  ];

  const careerContents = [
    '메타버스 플랫폼 회사 컬러버스에서 근무한 경험이 있습니다.',
    '재직 기간은 2021.09 ~ 2023.05 (총 1년 8개월)입니다.',
    '팀에서 사용한 기술은 TypeScript, React, Jotai, React-Query 입니다.',
    '프로젝트에서 맡았던 저의 업무는 다음과 같습니다.',
    '✔︎ TypeScript, React 사용하여 빌더 메인 페이지 구현',
    '✔︎ Jotai 사용하여 웹 페이지 전역 상태 관리',
    '✔︎ React-query 를 사용하여 서버 API 통신 작업',
  ];

  useEffect(() => {
    const aboutContents = window.document.querySelector('.about-me-contents');
    const aboutMecontainer = window.document.querySelector('.about-me');

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(
        (entry) => {
          if (entry.isIntersecting) {
            aboutMecontainer.style.opacity = 1;
            aboutMecontainer.style.transition = 'all 1s';
            aboutMecontainer.style.transform = 'translateX(-50px)';

            observer.unobserve(entry.target);
          }
        },
        { threshold: 0.5 }
      );
    });

    observer.observe(aboutContents);
  });

  return (
    <div className='about-me'>
      <div className='about-me-sub'>
        <span className='about-me-sub-title'>ABOUT ME</span>
      </div>
      <div className='about-me-contents'>
        {aboutMeContents.map((content, key) => (
          <div key={key}>{content}</div>
        ))}
      </div>
      <div style={{ height: '4rem' }} />
      <div className='about-me-sub'>
        <span className='about-me-sub-title'>Career</span>
      </div>
      <div className='about-me-contents'>
        <div
          className='education-intro-contents-link'
          onClick={() => window.open('https://colorverse.co/', '_blank')}
        >
          {' '}
          https://colorverse.co/
        </div>
        {careerContents.map((content, key) => (
          <div key={key}>{content}</div>
        ))}
      </div>
    </div>
  );
};

export default AboutMe;
